import classNames from 'classnames';
import LayoutFixed from './LayoutFixed';
import LayoutFlex from './LayoutFlex';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './css/Layout.scss';

export default function Layout({
    children,
    className,
    type,
    ...props
}) {
    const classes = classNames({
        [styles.layoutColumns]: type === 'columns',
        [styles.layoutRows]: type === 'rows',
    }, className);

    return (
        <div {...props} className={classes}>
            {children}
        </div>
    );
}

Layout.defaultProps = {
    type: 'columns',
};

Layout.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    type: PropTypes.oneOf(['columns', 'rows']).isRequired,
};

Layout.Flex = LayoutFlex;
Layout.Fixed = LayoutFixed;
